interface SchemaOrgProps {
  type: 'WebSite' | 'WebPage' | 'Article' | 'FAQPage' | 'Organization';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  const baseSchemas: Record<string, Record<string, unknown>> = {
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '漫境',
      url: 'https://manga-realm.readdy.ai/',
      description: '漫境 — 成人漫画精选推荐平台，提供正版授权、安全合规的成人漫画在线阅读体验。',
      potentialAction: {
        '@type': 'SearchAction',
        'target': {
          '@type': 'EntryPoint',
          urlTemplate: 'https://manga-realm.readdy.ai/search?q={search_term_string}',
        },
        'query-input': 'required name=search_term_string',
      },
    },
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '漫境',
      url: 'https://manga-realm.readdy.ai/',
      description: '漫境是专注于成人漫画精选推荐的在线阅读平台。',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'contact@manga-realm.readdy.ai',
        availableLanguage: ['Chinese'],
      },
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '漫境',
      url: 'https://manga-realm.readdy.ai/',
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
    },
  };

  const schema = { ...baseSchemas[type], ...data };

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}